// binabox/src/pages/dashboard/pages/users/modals/EditUser.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Form } from 'antd';
import { toast } from 'react-toastify';
import { editUser } from '../../../../../services/users/usersApi';

const EditUser = ({ isOpen, onClose, onSubmit, user }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [whatssap, setWhatssap] = useState('');
    const [photoProfil, setPhotoProfil] = useState(null);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (user) {
            // Populate fields if editing
            setUsername(user.username);
            setEmail(user.email);
            setWhatssap(user.whatssap || '');
            // Reset password and photoProfil for security reasons
            setPassword('');
            setPhotoProfil(null);
        } else {
            // Clear state if not editing
            clearState();
        }
    }, [user, isOpen]);

    const clearState = () => {
        setUsername('');
        setEmail('');
        setPassword('');
        setWhatssap('');
        setPhotoProfil(null);
        setErrors({});
    };

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('email', email);
        if (password) {
            formData.append('password', password);
        }
        formData.append('whatssap', whatssap);
        if (photoProfil) {
            formData.append('photo_profil', photoProfil);
        }

        editUser(user.id, formData)
            .then((response) => {
                toast.success('User updated successfully!');
                onSubmit(); // Refresh user list
                onClose(); // Close the modal
                clearState(); // Clear the form
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors); // Set errors from API response
                }
            });
    };

    return (
        <Modal
            title="Edit Utilisateur"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Modifier
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item
                    label="Nom d'utilisateur"
                    validateStatus={errors.username ? 'error' : ''}
                    help={errors.username ? errors.username[0] : ''}
                >
                    <Input
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Nom d'utilisateur"
                        required
                    />
                </Form.Item>
                <Form.Item
                    label="Email"
                    validateStatus={errors.email ? 'error' : ''}
                    help={errors.email ? errors.email[0] : ''}
                >
                    <Input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                </Form.Item>
                <Form.Item
                    label="Mot de passe"
                    validateStatus={errors.password ? 'error' : ''}
                    help={errors.password ? errors.password[0] : ''}
                >
                    <Input.Password
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Mot de passe (laisser vide pour ne pas changer)"
                    />
                </Form.Item>
                
                <Form.Item
                    label="WhatsApp"
                >
                    <Input
                        value={whatssap}
                        onChange={(e) => setWhatssap(e.target.value)}
                        placeholder="WhatsApp (optionnel)"
                    />
                </Form.Item>
                <Form.Item label="Photo de profil">
                    <Input
                        type="file"
                        onChange={(e) => setPhotoProfil(e.target.files[0])}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditUser;